<template>
  <b-col
    lg="12"
    :class="['pubdatebutton', !publishDateData.showPubDate ? 'shorterwidth' : '']"
  >
    <div v-if="publishDateData.tempSelectedPeriod==='consumptionperiod'">
      <div v-if="publishDateData.showPubDate">
        <b-row>
          <b-col
            lg="6"
            class="pubdatefromwrapper"
          >
            <label class="label-text">
              Publiceringsdatum från
            </label>
            <date-picker
              id="pub-date-from-datepicker"
              v-model="publishDateData.tempPublishStartDate"   
              :months="datepickerObject.months"
              :weekdays="datepickerObject.weekdays"
              :show-week-number="true"
              class="pubDateFromDatepicker"
              value-type="format"
              :disabled-date="isFromDateDisabled"
              :clearable="false"
            />
          </b-col>
            
          <b-col
            lg="6"
            class="pubdatetowrapper"
          >
            <div>
              <label class="label-text">
                Publiceringsdatum till
              </label>
              <b-button
                size="sm"
                variant="primary"
                class="donotusebtn"
                @click="hidePubDate"
              >
                använd ej
              </b-button>
            </div>
            <date-picker
              id="pub-date-to-datepicker"
              v-model="publishDateData.tempPublishEndDate"
              :months="datepickerObject.months"
              :weekdays="datepickerObject.weekdays"             
              :show-week-number="true"
              class="pubDateToDatepicker"
              value-type="format"
              :disabled-date="isEndDateDisabled"
              :clearable="false"
            />
          </b-col>
        </b-row>
      </div>
      <button
        v-else
        type="button"
        class="btn btnclass usepubdatebtn"
        @click="clickedPublishDate"
      >
        Använd pubdatum
      </button>
    </div>
  </b-col>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/sv';
import   {
    isDateNotBetweenTwoDates,
} from '../../../assets/js/utils.js';


export default {
    name: "PublishDate",
    components: {
        DatePicker,
    },
    props: {
        datepickerObject: Object,
        publishDateData: Object
    },
    watch: {
      "publishDateData.tempPublishStartDate"(startDate) {
          if (startDate > this.publishDateData.tempPublishEndDate)
            this.publishDateData.tempPublishEndDate = startDate;
      },
      "publishDateData.tempPublishEndDate"(endDate) {
          if (this.publishDateData.tempPublishStartDate > endDate)
            this.publishDateData.tempPublishStartDate = endDate;
      }
    },
    methods: {
        clickedPublishDate() {
            this.publishDateData.showPubDate = true;
            this.publishDateData.tempPublishStartDate = this.publishDateData.tempStartDate;
            this.publishDateData.tempPublishEndDate = this.publishDateData.tempEndDate;
        },
        hidePubDate() {
            this.publishDateData.showPubDate = false;
        }, 
        isFromDateDisabled(date) {
            let disableDate = isDateNotBetweenTwoDates(
                date,
                new Date(this.$store.state.systemInfo.publishedFromDate),
                new Date(this.$store.state.systemInfo.publishedToDate),
            );
            if (new Date(this.end_date).setHours(0, 0, 0) < date) disableDate = true;
            return disableDate;
        },
        isEndDateDisabled(date) {
            let disableDate = isDateNotBetweenTwoDates(
                date,
                new Date(this.$store.state.systemInfo.publishedFromDate),
                new Date(this.$store.state.systemInfo.publishedToDate),
            );
            if (new Date(this.start_date).setHours(0, 0, 0) > date) disableDate = true;
            return disableDate;
        },
    }
}
</script>
<style scoped>
@media (width <= 1330px) {
  label.label-text{
    font-size: .65rem;
  }
}

.pubDateFromDatepicker, .pubDateToDatepicker{
  width: 100%;
}
.pubdatefromwrapper{
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.pubdatetowrapper{
  margin-left: -0.3125rem;
}
.donotusebtn {
  font-size: 0.5625em;
  padding-right: 0.188rem;
  padding-left: 0.188rem;
  padding-top: 0.2em;
  float: right;
}
.pubdatebutton {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  max-height: 3.32rem;
}
>>> .pubDateToDatepicker button {
  margin-top: 0px;
}
.usepubdatebtn{
  white-space: nowrap;
  font-size: .7rem;
}
</style>
